import { render, staticRenderFns } from "./sms-settings.vue?vue&type=template&id=32701888&scoped=true"
import script from "./sms-settings.vue?vue&type=script&lang=js"
export * from "./sms-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32701888",
  null
  
)

export default component.exports